<template>
  <DropdownItem class="header-menu-item" :link="link" v-bind="$attrs" @click.native="handleMenuClick(menu)">
    <div class="header-menu-item__icon">
      <Component :is="icon" width="24" height="24" />
    </div>
    <div class="header-menu-item__title">
      <slot />
    </div>
    <BravadoTheme v-if="isNew" forced-theme="dark">
      <BravadoText tag="span" variant="caption3-semibold" class="header-menu-item__new">new</BravadoText>
    </BravadoTheme>
  </DropdownItem>
</template>

<script>
import { DropdownItem } from '~/components/common/Dropdown';
import BravadoTheme from '~/components/common/BravadoTheme/BravadoTheme';

export default {
  name: 'HeaderMenuItem',
  components: {
    DropdownItem,
    BravadoTheme,
  },
  props: {
    menu: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return () => import(`@/components/Icon/${this.menu}.vue`);
    },
  },
  methods: {
    handleMenuClick(element) {
      this.$analytics.logEvent(`global__header-nav__${element}__click`);
    },
  },
};
</script>

<style lang="scss" scoped>
.header-menu-item {
  @include body;

  $this: &;

  color: var(--theme-color-text);
  width: 100%;
  padding: 8px 16px;
  display: flex;
  align-items: center;

  &__icon {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: var(--theme-color-over-card);
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--theme-color-sub-text);
  }

  &__title {
    flex-grow: 1;
  }

  &__new {
    color: var(--theme-color-soft-skin);
    background: var(--gold-50);
    border-radius: 4px;
    padding: 4px;
    text-transform: uppercase;
  }
}
</style>
